<template>
  <div class="multiple-upload">
    <v-layout wrap>
      <v-flex v-for="(image, index) in images" :key="`image_${index}`" xs6 d-flex>
        <v-card flat class="d-flex">
          <v-card-text v-if="image && image.url">
            <div style="border-radius: 10px; border: 1px solid #eeee; position: relative">
              <v-img :src="image.url" aspect-ratio="1" class="grey lighten-2">
                <template #placeholder>
                  <v-layout fill-height align-center justify-center ma-0>
                    <v-progress-circular indeterminate color="grey lighten-5"></v-progress-circular>
                  </v-layout>
                </template>
              </v-img>

              <div
                style="position: absolute; right: 0px; top: 0px"
                @click="handleDeleteImage(index)"
              >
                <v-btn icon><v-icon>delete</v-icon></v-btn>
              </div>
            </div>
          </v-card-text>
          <v-card-text v-else>
            <div style="border-radius: 10px; border: 1px solid #eeee; position: relative">
              <v-img :src="image" aspect-ratio="1" class="grey lighten-2">
                <template #placeholder>
                  <v-layout fill-height align-center justify-center ma-0>
                    <v-progress-circular indeterminate color="grey lighten-5"></v-progress-circular>
                  </v-layout>
                </template>
              </v-img>

              <div
                style="position: absolute; right: 0px; top: 0px"
                @click="handleDeleteImage(index)"
              >
                <v-btn icon><v-icon>delete</v-icon></v-btn>
              </div>
            </div>
          </v-card-text>
        </v-card>
      </v-flex>
    </v-layout>
    <template v-if="images.length < maxLength && !loading">
      <div
        class="text-xs-center imageBtn"
        :class="{ dropover: isDropover }"
        @click="onAddImage"
        @dragover="onDragover"
        @dragleave="onDragleave"
        @drop="onDrop"
      >
        <v-layout justify-center align-center row style="height: 100%" class="py-4 px-2">
          <div class="text-xs-center">Click to upload or drag image to here</div>
        </v-layout>
      </div>
    </template>

    <input
      :id="`photoUploadInput-${id}`"
      type="file"
      accept="image/*"
      multiple
      style="
        height: 0px;
        width: 0px;
        visibility: hidden;
        position: fixed;
        margin-left: -999px;
        left: 0;
      "
      @input="onFileChange($event)"
    />
  </div>
</template>

<script>
import api from '@/api'
const events = ['dragenter', 'dragover', 'dragleave', 'drop']

import FileUpload from 'vue-upload-component'
export default {
  components: {
    FileUpload
  },
  props: { id: {}, value: {}, maxLength: { default: 2 } },
  data() {
    return {
      images: [],
      singleImage: null,
      isDropover: false,
      loading: false
    }
  },
  computed: {},
  mounted() {
    events.forEach((eventName) => {
      document.body.addEventListener(eventName, this.preventDefaults)
    })
    this.images = this.value
  },
  beforeDestroy() {
    events.forEach((eventName) => {
      document.body.removeEventListener(eventName, this.preventDefaults)
    })
  },
  methods: {
    async handleSendMultipleImages(images) {
      const vm = this
      const s3url = await Promise.all(
        images.map(async (obj) => {
          if (typeof obj == 'string') {
            return obj
          } else {
            return await vm.createImage(obj.file)
          }
        })
      )
      return s3url
    },
    onAddImage() {
      document.getElementById(`photoUploadInput-${this.id}`).click()
    },
    async onFileChange() {
      const files = event.target.files || event.dataTransfer.files
      this.addImageIntoArray([...files])
      const images = await this.handleSendMultipleImages(this.images)
      this.$emit('update', images)
    },
    handleCancel() {
      this.images = []
      this.$emit('input', false)
    },
    uploadImages() {},
    onDragover(e) {
      e.preventDefault()
      this.isDropover = true
    },
    onDragleave(e) {
      this.isDropover = false
    },
    async onDrop(e) {
      e.preventDefault()
      const files = [...e.dataTransfer.files]
      this.addImageIntoArray(files)
      const images = await this.handleSendMultipleImages(this.images)
      this.$emit('update', images)
    },
    addImageIntoArray(files) {
      const images = files.filter((file) => {
        const type = file.type.toLowerCase()
        return type == 'image/png' || type == 'image/jpeg' || type == 'image/jpg'
      })

      if (images) {
        const imageWithUrl = images.map((image) => {
          return {
            file: image,
            url: URL.createObjectURL(image)
          }
        })
        const spliceImages = [...this.images, ...imageWithUrl]
        this.images = spliceImages.slice(0, this.maxLength)
      }
    },
    handleDeleteImage(index) {
      this.images.splice(index, 1)
      this.$emit('update', this.images)
    },
    async createImage(file) {
      try {
        return await this.upload(file)
      } catch (error) {
        this.$swal({
          title: 'เกิดข้อผิดพลาดกรุณาลองใหม่อีกครั้ง',
          type: 'error',
          text: `upload: ${error}`,
          confirmButtonText: this.$t('Confirm')
        })
      }
    },
    upload(file) {
      let data = {
        name: file.name,
        type: file.type,
        file: file
      }
      let vm = this
      return new Promise((resolve, reject) => {
        api.getSignedRequest(data, function (error, url) {
          if (error) {
            reject(error)
          }

          url = encodeURI(url)

          vm.currentImage = url
          // vm.$emit('input', vm.currentImage, { width: vm.tempWidth, height: vm.tempHeight })
          if (vm.multiple) {
            vm.multiplefile.push(vm.currentImage)
            if (vm.filelength == vm.multiplefile.length) {
              vm.$emit('onUploaded', vm.multiplefile)
            }
          } else {
            vm.$emit('onUploaded', vm.currentImage)
          }
          resolve(vm.currentImage)
        })
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.imageBtn {
  height: 80px;
  border: 3px dashed #eee;
  border-radius: 10px;
  cursor: pointer;
  &:hover {
    background: #eee;
  }
  &.dropover {
    background: #eee;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/elements/UploadMultipleImage/UploadMultipleImageShow.vue